import React from "react";
import "./Header.css";

export default function Header() {
  return (
    <header className="crypto-header">
      <h1>Degen Den Academy – Finance & Crypto Lab</h1>
      <p className="subtitle">
        Learn finance & crypto with us ↓
      </p>
    </header>
  );
}
